<template>
  <v-form ref="form" v-model="validForm">
    <v-row :no-gutters="$vuetify.breakpoint.smAndDown" class="align-end">
      <v-col cols="12" class="col-md-4">
        <div class="form-input">
          <label :for="'surname'">{{ bookData.surnameField }}</label>
          <v-text-field
            class="mt-4 text-field"
            :id="'surname'"
            v-model="value.lastName"
            outlined
            dense
            clearable
            color="#FFA903"
            flat
            style="border-radius: 0 !important;"
            required
            :rules="nameRules"
          />
        </div>
      </v-col>

      <v-col cols="12" class="col-md-4">
        <div class="form-input">
          <label :for="'name'">{{ bookData.nameField }}</label>
          <v-text-field
            class="mt-4 text-field"
            :id="'name'"
            v-model="value.firstName"
            outlined
            dense
            clearable
            color="#FFA903"
            flat
            style="border-radius: 0 !important;"
            :rules="nameRules"
          />
        </div>
      </v-col>
      <v-col cols="12" class="col-md-4">
        <div class="form-input">
          <label :for="'patronymic'">{{ bookData.patronymicField }}</label>
          <v-text-field
            class="mt-4 text-field"
            :id="'patronymic'"
            v-model="value.patronymic"
            outlined
            dense
            clearable
            color="#FFA903"
            flat
            style="border-radius: 0 !important;"
            :rules="nameRules"
          />
        </div>
      </v-col>
    </v-row>
    <v-row :no-gutters="$vuetify.breakpoint.smAndDown" class="align-end">
      <v-col cols="12" class="col-md-4">
        <div class="form-input">
          <label :for="'tel'">{{ bookData.numberField }}</label>
          <v-text-field
            class="mt-4 text-field"
            type="tel"
            :id="'tel'"
            v-model="value.phone"
            aria-invalid="false"
            aria-required="true"
            outlined
            dense
            clearable
            color="#FFA903"
            flat
            style="border-radius: 0 !important;"
            required
            :rules="telRules"
          />
        </div>
      </v-col>

      <v-col cols="12" class="col-md-4">
        <div class="form-input">
          <label :for="'email'">E-mail*</label>
          <v-text-field
            class="mt-4 text-field"
            :id="'email'"
            v-model="value.email"
            type="email"
            outlined
            dense
            clearable
            color="#FFA903"
            flat
            style="border-radius: 0 !important;"
            required
            :rules="emailRules"
          />
        </div>
      </v-col>
      <!--      <v-col v-if="!short" cols="12" class="col-md-4">-->
      <!--        <div class="form-input">-->
      <!--          <label :for="'seria'">{{ bookData.passportField }}</label>-->
      <!--          <v-text-field-->
      <!--            class="mt-4 text-field"-->
      <!--            :id="'seria'"-->
      <!--            v-model="value.passport"-->
      <!--            outlined-->
      <!--            dense-->
      <!--            clearable-->
      <!--            color="#FFA903"-->
      <!--            flat-->
      <!--            style="border-radius: 0 !important;"-->
      <!--            required-->
      <!--            :rules="nameRules"-->
      <!--          />-->
      <!--        </div>-->
      <!--      </v-col>-->
    </v-row>
    <!--    <v-row-->
    <!--      v-if="!short"-->
    <!--      :no-gutters="$vuetify.breakpoint.smAndDown"-->
    <!--      class="align-end"-->
    <!--    >-->
    <!--      <v-col cols="12" class="col-md-4">-->
    <!--        <div class="form-input">-->
    <!--          <label :for="'date'">{{ bookData.issuedDateField }}</label>-->
    <!--          <v-menu max-width="290" :close-on-content-click="false">-->
    <!--            <template v-slot:activator="{ on, attrs }">-->
    <!--              <v-text-field-->
    <!--                :id="'date'"-->
    <!--                :value="value.passportGivenWhen"-->
    <!--                clearable-->
    <!--                readonly-->
    <!--                v-bind="attrs"-->
    <!--                v-on="on"-->
    <!--                @click:clear="value.passportGivenWhen = null"-->
    <!--                class="mt-4 text-field"-->
    <!--                outlined-->
    <!--                dense-->
    <!--                color="#FFA903"-->
    <!--                flat-->
    <!--                append-icon="mdi-calendar"-->
    <!--                style="border-radius: 0 !important;"-->
    <!--                required-->
    <!--                :rules="nameRules"-->
    <!--              ></v-text-field>-->
    <!--            </template>-->
    <!--            <v-date-picker-->
    <!--              v-model="value.passportGivenWhen"-->
    <!--              :first-day-of-week="1"-->
    <!--              color="#FFA903"-->
    <!--              locale="ru-RU"-->
    <!--            ></v-date-picker>-->
    <!--          </v-menu>-->
    <!--        </div>-->
    <!--      </v-col>-->

    <!--      <v-col cols="12" class="col-md-8">-->
    <!--        <div class="form-input">-->
    <!--          <label :for="'issued'">{{ bookData.issuedField }}</label>-->
    <!--          <v-text-field-->
    <!--            class="mt-4 text-field"-->
    <!--            :id="'issued'"-->
    <!--            v-model="value.passportGivenBy"-->
    <!--            outlined-->
    <!--            dense-->
    <!--            clearable-->
    <!--            color="#FFA903"-->
    <!--            flat-->
    <!--            style="border-radius: 0 !important;"-->
    <!--            required-->
    <!--            :rules="nameRules"-->
    <!--          />-->
    <!--        </div>-->
    <!--      </v-col>-->
    <!--    </v-row>-->
    <v-row
      v-if="!short"
      :no-gutters="$vuetify.breakpoint.smAndDown"
      class="align-end"
    >
      <v-col cols="12" class="col-md-4">
        <div class="form-input">
          <label for="birthday">{{ bookData.registrationDateField }}</label>
          <v-menu max-width="290" :close-on-content-click="false">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                :id="'birthday'"
                :value="value.birthday"
                clearable
                readonly
                v-bind="attrs"
                v-on="on"
                @click:clear="value.birthday = null"
                class="mt-4 text-field"
                outlined
                dense
                color="#FFA903"
                flat
                append-icon="mdi-calendar"
                style="border-radius: 0 !important;"
                required
                :rules="nameRules"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="value.birthday"
              :first-day-of-week="1"
              :max="today"
              color="#FFA903"
              locale="ru-RU"
            ></v-date-picker>
          </v-menu>
        </div>
      </v-col>

      <!--      <v-col cols="12" class="col-md-8">-->
      <!--        <div class="form-input">-->
      <!--          <label :for="'registerAddress'">{{-->
      <!--            bookData.registrationAddressField-->
      <!--          }}</label>-->
      <!--          <v-text-field-->
      <!--            class="mt-4 text-field"-->
      <!--            :id="'registerAddress'"-->
      <!--            v-model="value.registerAddress"-->
      <!--            outlined-->
      <!--            dense-->
      <!--            clearable-->
      <!--            color="#FFA903"-->
      <!--            flat-->
      <!--            style="border-radius: 0 !important;"-->
      <!--            required-->
      <!--            :rules="nameRules"-->
      <!--          />-->
      <!--        </div>-->
      <!--      </v-col>-->

      <!--      <v-col v-if="!short" cols="12" class="col-md-4">-->
      <!--        <div class="select">-->
      <!--          <label :for="'location'">{{ bookData.cityField }}</label>-->
      <!--          <v-menu offset-y>-->
      <!--            <template v-slot:activator="{ on, attrs }">-->
      <!--              <v-btn-->
      <!--                class="mt-4 text-field secondary-btn selectButton"-->
      <!--                outlined-->
      <!--                v-bind="attrs"-->
      <!--                v-on="on"-->
      <!--                style="border-color: #CECED8 !important"-->
      <!--                width="325"-->
      <!--                height="40"-->
      <!--              >-->
      <!--                {{ selectedLocationLabel }}-->
      <!--                <v-icon right large>mdi-chevron-down</v-icon>-->
      <!--              </v-btn>-->
      <!--            </template>-->
      <!--            <v-list>-->
      <!--              <v-list-item-->
      <!--                v-for="location in locations"-->
      <!--                :key="location.value"-->
      <!--                class="px-5"-->
      <!--                style="cursor: pointer"-->
      <!--                @click="selectedLocation = location"-->
      <!--              >-->
      <!--                {{ location.label }}-->
      <!--              </v-list-item>-->
      <!--            </v-list>-->
      <!--          </v-menu>-->
      <!--        </div>-->
      <!--      </v-col>-->
    </v-row>
    <v-row>
      <v-col cols="12" class="col-md-8">
        <Coupon
          id="code"
          :label="bookData.couponField"
          :rules="nameRules"
          v-model="value.couponCode"
          @getCoupon="getCouponValue"
          :disabled="value.coupon > 0"
        />
      </v-col>
    </v-row>
    <v-btn
      class="main-btn rounded-0 text-capitalize mt-7"
      @click="submit"
      :disabled="!validForm"
      color="#FFA903"
    >
      {{ bookData.formSubmitTitle }}
    </v-btn>
  </v-form>
</template>

<script>
import Coupon from "@/components/Coupon";

export default {
  name: "AdultForm",
  props: ["value", "short"],
  components: { Coupon },
  computed: {
    bookData() {
      return this.$t("book");
    },
    locations() {
      return this.$t("book").locationOptions;
    },
    selectedLocationLabel() {
      return (
        this.locations.find(
          ({ value }) => this.selectedLocation.value === value
        )?.label ?? ""
      );
    }
  },
  data() {
    return {
      today: new Date().toISOString(),
      validForm: false,
      nameRules: [v => !!v || "Enter field"],
      telRules: [v => !!v || "Enter phone number"],
      emailRules: [
        v => !!v || "Enter email",
        v => /.+@.+\..+/.test(v) || "Invalid email value"
      ],
      selectedLocation: {}
    };
  },
  mounted() {
    this.selectedLocation = this.locations?.[0];
  },
  methods: {
    submit() {
      const form = this.$refs.form;
      if (form.validate())
        this.$emit("submitAdultForm", {
          ...this.value,
          transferOrigin: this.selectedLocation.value,
          couponCode: this.value.coupon > 0 ? this.value.couponCode : null
        });
    },
    getCouponValue(amount) {
      this.value.coupon = amount;
      this.$emit("applyCoupon", this.value);
    }
  }
};
</script>

<style lang="sass" scoped></style>

<style lang="scss">
.select {
  button {
    width: 100% !important;
  }

  .v-btn__content {
    justify-content: space-between;
    font-family: Roboto, sans-serif !important;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 24px;
  }
}
</style>
